export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const POPUP_ALERT = 'POPUP_ALERT';

export const popupAlert = data => ({
  type: POPUP_ALERT,
  data,
});
